import styled from '@emotion/styled';
import { ChevronRight } from 'lucide-react';

export const MainBlock = styled.div`
  display: flex;
  flex-direction: column;

  width: 48px;
  padding: 8px;
  gap: 8px;
  border-right: 1px solid #e2e3e4;
  background: #fffdff;

  align-items: center;
`;
const Button = styled.button`
  border: none;
  background: none;
  cursor: pointer;
`;
export const IconButton = styled(Button)`
  max-width: 32px;
  max-height: 32px;
  width: 32px;
  height: 32px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: #242424;
  transition: color 0.2s ease-in-out;

  &:focus-visible {
    outline: unset;
  }

  &:disabled {
    color: #c4c4c4;
    cursor: not-allowed;

    &:hover {
      color: #c4c4c4;
    }
  }

  &:hover {
    color: #d9b244;
  }
`;
export const ModalButton = styled(Button)`
  display: flex;
  align-items: center;
  padding-inline: 20px;
  min-height: 24px;
  padding-block: 8px;
  gap: 8px;

  &:hover {
    background: #fffae2;
  }
`;

export function IconWrapper({ icon }: { icon: React.ReactNode }) {
  return (
    <div className="flex-center" style={{ position: 'relative', width: 32, height: 32 }}>
      {icon}
    </div>
  );
}

export function OpenerIconWrapper({ icon }: { icon: React.ReactNode }) {
  return (
    <div className="flex-center" style={{ position: 'relative', width: 32, height: 32 }}>
      {icon}
      <ChevronRight size={12} style={{ position: 'absolute', right: -5 }} />
    </div>
  );
}
